"use client"

import { useState } from "react"
import { Menu, X, Phone } from "lucide-react"

const Header = ({ isScrolled }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen)
  }

  return (
    <header
      className={`fixed w-full z-50 transition-all duration-300 ${
        isScrolled ? "bg-white shadow-md py-2" : "bg-transparent py-4"
      }`}
    >
      <div className="container mx-auto px-4 flex justify-between items-center">
        <div className="flex items-center">
          <div style={{ width: '120px', height: '56px', position: 'relative' }}>
            <img 
              src="/logo.webp" 
              alt="Zak Ferrailleur Épaviste Saint-Étienne" 
              className="w-full h-full object-contain" 
              width="120"
              height="56"
              style={{ aspectRatio: '120/56' }}
            />
          </div>
        </div>

        {/* Navigation desktop */}
        <nav className="hidden md:flex items-center">
          <ul className="flex space-x-6">
            {["Accueil", "À propos", "Tarifs", "Fonctionnement", "Contact"].map((item) => (
              <li key={item}>
                <a
                  href={`#${item.toLowerCase().replace("à ", "")}`}
                  className={`font-medium hover:text-green-500 transition-colors ${
                    isScrolled ? "text-gray-700" : "text-white"
                  }`}
                >
                  {item}
                </a>
              </li>
            ))}
          </ul>

          <a
              href="tel:+33614868693"
              className={`flex items-center px-4 py-2 mx-4 rounded-lg transition-all ${
                  isScrolled
                      ? "bg-green-600 hover:bg-green-700 text-white"
                      : "bg-white/20 hover:bg-white/30 text-white backdrop-blur-sm"
              }`}
          >
            <Phone className="h-4 w-4 mr-2" />
            <span className="font-medium">06 14 86 86 93</span>
          </a>
        </nav>

        {/* Bouton menu mobile */}
        <button className="md:hidden text-2xl" onClick={toggleMenu} aria-label="Menu">
          {isMenuOpen ? (
            <X className={isScrolled ? "text-gray-800" : "text-white"} />
          ) : (
            <Menu className={isScrolled ? "text-gray-800" : "text-white"} />
          )}
        </button>
      </div>

      {/* Menu mobile */}
      {isMenuOpen && (
        <div className="md:hidden bg-white shadow-lg absolute top-full left-0 w-full">
          <ul className="py-4">
            <li className="px-4 py-2 border-b border-gray-100">
              <a
                href="tel:+33614868693"
                className="flex items-center font-medium text-green-600"
                onClick={() => setIsMenuOpen(false)}
              >
                <Phone className="h-5 w-5 mr-2" />
                <span>06 14 86 86 93</span>
              </a>
            </li>
            {["Accueil", "À propos", "Tarifs", "Fonctionnement", "Contact"].map((item) => (
              <li key={item} className="px-4 py-2">
                <a
                  href={`#${item.toLowerCase().replace("à ", "")}`}
                  className="block font-medium text-gray-800 hover:text-green-500 transition-colors"
                  onClick={() => setIsMenuOpen(false)}
                >
                  {item}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </header>
  )
}

export default Header
